<header class="justify-content-between d-flex tiles-header ml-1">
  <div class="d-flex justify-content-start tiles-header-left">
    @if (auth.loginState$ | async; as state) {
      @if (!!state) {
        <div class="tiles-home">
          <a routerLink="./" aria-label="Home" tabindex="0"><i class="far fa-home"></i></a>
        </div>
        @if (profile.profile) {
          <div class="tiles-favorite" tabindex="0" title="My Favorites" (keyup.enter)="openModal(true, 'My Favorites', 'MyFavorites', '')" (click)="openModal(true, 'My Favorites', 'MyFavorites', '')">
            <i class="fas fa-star fave-star" [ngClass]="{'active' : profile.profile.favorites && profile.profile.favorites.length > 0}"></i>
          </div>
        }
        @if (auth.hasFeature('Search')) {
          <div class="input-group border rounded search-box">
            <input #searchBox type="search" (keyup.enter)="search()" class="form-control rounded" placeholder="Search" aria-label="Search" aria-describedby="search-addon" />
            <span class="input-group-text border-0" id="search-addon">
              <a [routerLink]="searchBox.value?'../search':null" id="searchLink" aria-label="Search" [queryParams]="{q: searchBox.value, t: this.profile.searchFilter}">
                <i class="fas fa-search" [ngClass]="{'disabled':!searchBox.value}"></i>
              </a>
            </span>
          </div>
        }
      }
    }

    <!-- DEV/TEST WARNING -->
    @if (!prod) {
      <div>
        <span class="environmentWarning d-none d-sm-block" (click)="toggleShowDebug()">WARNING: Non-Prod DB</span>
        <span class="environmentWarningSm d-sm-none" (click)="toggleShowDebug()"><i class="fas fa-database"></i></span>
      </div>
    }

  </div>

  <!-- Login Timeout Message -->
  @if (auth.loginState$ | async; as state) {
    <div class="app-backdrop text-center" [ngClass]="{ show: state < 3 || state > 6  }">
      <div class="h-100 row align-items-center">
        <div class="col text-warning">
          <h3>[{{getStateMessage(state)}}]</h3>
          @if (showLoginButton(state)) {
            <button type="button" class="btn btn-warning" (click)="auth.redirectToCurrentPage(this._router.url)">Log back in</button>
          }
        </div>
      </div>
    </div>
  }

  <div class="d-flex justify-content-end tiles-header-right">
    <app-notifications class="notifications-header"></app-notifications>
    <app-utility-navigation (anything)="closeAside" class="tiles-ui-utility-navigation utility-navigation-top-bar"></app-utility-navigation>
  </div>
</header>

<div class="tiles-header-bar justify-content-between d-flex">
  <div class="d-flex justify-content-start tiles-header-intro">
    @if (profile.profile$ | async; as profile;) {
      {{dayMessage}}, {{profile.biodata.firstName}}!
    }

  </div>
  <div class="d-flex justify-content-end tiles-header-tagline">
    IT TAKES ALL OF B<span class="tiles-header-tagline-us">US</span>INESS.
  </div>
</div>

<app-alert class="tiles-alert"></app-alert>
